module.exports = __webpack_public_path__ + "img/77cbd8b.jpg";